import axios from 'axios'
import { The, createJsonData } from 'helpers/generalHelpers'
import { HTTP } from 'types'
import { APIURL, config, getCurrentWorkspace } from './_utils'

const workspace = getCurrentWorkspace()

export const emailTemplate = {
  create: (formData) =>
    The(
      axios.post(
        `${APIURL}/v4/email-templates/`,
        createJsonData(formData),
        config({
          contentType: HTTP.ContentTypes.JSON,
          workspace,
        })
      )
    ),
  get: (tempSlug) =>
    The(
      axios.get(
        `${APIURL}/v4/email-templates/${tempSlug}/`,
        config({ workspace })
      )
    ),

  getAll: (params = {}) =>
    The(
      axios.get(`${APIURL}/v4/email-templates/`, config({ params, workspace }))
    ),

  update: (tempSlug, formData) =>
    The(
      axios.patch(
        `${APIURL}/v4/email-templates/${tempSlug}/`,
        createJsonData(formData, {
          alwaysSend: ['email_server_slug', 'reply_to_email'],
        }),
        config({
          contentType: HTTP.ContentTypes.JSON,
          workspace,
        })
      )
    ),

  duplicate: (tempSlug, formData = {}) =>
    The(
      axios.post(
        `${APIURL}/v4/email-templates/${tempSlug}/copy/`,
        createJsonData(formData),
        config({
          contentType: HTTP.ContentTypes.JSON,
          workspace,
        })
      )
    ),

  delete: (tempSlug) =>
    The(
      axios.delete(
        `${APIURL}/v4/email-templates/${tempSlug}/`,
        config({ workspace })
      )
    ),

  getSampleList: (formSlug, params = {}) =>
    The(
      axios.get(
        `${APIURL}/v4/email-template-examples/`,
        config({ params, workspace })
      )
    ),
}
